import _slicedToArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
// Copyright 2017-2021 @polkadot/util-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { base58Decode } from "../base58/decode.mjs";
import { checkAddressChecksum } from "./checksum.mjs";
import { defaults } from "./defaults.mjs";
/**
 * @name checkAddress
 * @summary Validates an ss58 address.
 * @description
 * From the provided input, validate that the address is a valid input.
 */

export function checkAddress(address, prefix) {
  var decoded;

  try {
    decoded = base58Decode(address);
  } catch (error) {
    return [false, error.message];
  }

  var _checkAddressChecksum = checkAddressChecksum(decoded),
      _checkAddressChecksum2 = _slicedToArray(_checkAddressChecksum, 4),
      isValid = _checkAddressChecksum2[0],
      ss58Decoded = _checkAddressChecksum2[3];

  if (ss58Decoded !== prefix) {
    return [false, "Prefix mismatch, expected ".concat(prefix, ", found ").concat(ss58Decoded)];
  } else if (!defaults.allowedEncodedLengths.includes(decoded.length)) {
    return [false, 'Invalid decoded address length'];
  }

  return [isValid, isValid ? null : 'Invalid decoded address checksum'];
}